import { render, staticRenderFns } from "./InterviewLetter.vue?vue&type=template&id=1b83531b"
import script from "./InterviewLetter.vue?vue&type=script&lang=js"
export * from "./InterviewLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b83531b')) {
      api.createRecord('1b83531b', component.options)
    } else {
      api.reload('1b83531b', component.options)
    }
    module.hot.accept("./InterviewLetter.vue?vue&type=template&id=1b83531b", function () {
      api.rerender('1b83531b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/InterviewLetter.vue"
export default component.exports